import { styled } from '@zoopla-eng/zds-components/themes';

export const StyledLabel = styled('label', {
    fontGroup: 'ladle',
    fontWeight: '$400',
    color: '$textBody',
    '&:focus': {
        outline: 'none'
    },
    '&:focus-visible': {
        outline: 'none',
        boxShadow: '$focusRing'
    }
});

export const StyledAnswerContainer = styled('div', {
    display: 'grid',
    templateColumns: '80% auto',
    justifyContent: 'space-between',
    borderRadius: '$400',
    p: '$S400',
    bg: '$brandPrimaryT4',
    '@M100': {
        templateColumns: '1fr auto'
    }
});

export const StyledAnswerText = styled('p', {
    fontGroup: 'fork',
    '& span': {
        pb: '$S300',
        display: 'block'
    },
    '& strong': {
        fontGroup: 'ladle'
    }
});

export const StyledErrorText = styled('p', {
    fontGroup: 'ladle',
    color: '$functionalError'
});
